import React from 'react';
import LegalPageLayout from '../components/LegalPageLayout';

export default function TermsPage() {
  return (
    <LegalPageLayout title="Terms of Service" effectiveDate="October 25, 2026">
      <section>
        <h2>1. The service</h2>
        <p>GetScribeDash provides AI-assisted document scanning, optical character recognition, image enhancement, and human-assisted transcription and review. Features and availability may change as the service develops.</p>
      </section>

      <section>
        <h2>2. Accounts</h2>
        <p>You must provide accurate account information, protect your credentials, and promptly report suspected unauthorized access. Email verification is required before processing documents or purchasing credits. A newly verified account currently receives three promotional scan credits.</p>
      </section>

      <section>
        <h2>3. Credits and payments</h2>
        <ul>
          <li>A standard OCR submission currently uses one scan credit. Image enhancement combined with OCR currently uses two scan credits.</li>
          <li>A scan credit is deducted only after readable text is returned, the uploaded file is stored, and the document record is created. If processing fails before submission completes, the system does not deduct the scan credit.</li>
          <li>Human transcription services may have an additional price shown before you enter Stripe Checkout. Work requiring payment is not released into the transcription queue until payment is confirmed.</li>
          <li>Credit packages, transcription prices, and any valid promotion are displayed before checkout. Payments are processed by Stripe; GetScribeDash does not receive or store complete payment-card numbers.</li>
          <li>Except where required by law, purchases are generally final once the purchased service or credits have been used. Contact us if a verified platform failure prevented delivery so we can review an appropriate credit adjustment or refund.</li>
        </ul>
      </section>

      <section>
        <h2>4. Your content</h2>
        <p>You retain ownership of documents and text you submit. You grant GetScribeDash a limited, non-exclusive license to store, display, transmit, process, enhance, and reproduce that content only as needed to provide, secure, support, and improve the requested service.</p>
      </section>

      <section>
        <h2>5. AI and human review</h2>
        <p>Uploaded documents may be processed by third-party AI providers and, when the workflow requires it, viewed by authorized transcribers or administrators. Automated and human outputs can contain mistakes. You are responsible for reviewing completed text before relying on it for legal, medical, financial, safety-critical, or other consequential purposes.</p>
      </section>

      <section>
        <h2>6. Acceptable use</h2>
        <p>You may not use the service to upload malware, violate law, infringe intellectual-property or privacy rights, evade security controls, access another user’s content, or interfere with the service. You represent that you have the rights and permissions needed to submit each document.</p>
      </section>

      <section>
        <h2>7. Availability and disclaimers</h2>
        <p>The service and its outputs are provided on an “as available” basis. Document quality, handwriting, provider availability, and human review can affect speed and accuracy. To the extent permitted by law, GetScribeDash disclaims implied warranties and is not responsible for losses caused by relying on an output without appropriate review.</p>
      </section>

      <section>
        <h2>8. Suspension and changes</h2>
        <p>We may restrict or suspend access when reasonably necessary to protect users, the service, or third parties, or to respond to suspected violations. We may update these Terms and will publish a revised effective date when we do.</p>
      </section>

      <section>
        <h2>9. Contact</h2>
        <p>Questions about these Terms, billing, or service delivery may be sent to <a className="text-[var(--brand-primary)] hover:underline" href="mailto:admin@getscribedash.com">admin@getscribedash.com</a>.</p>
      </section>
    </LegalPageLayout>
  );
}
